/* desdo.shopify Pageflip - requires page-flip.browser.js */
(function () {
  'use strict';

  function initDesdaPageflip(root) {
    if (!root || root.dataset.desdaReady === '1') return;
    root.dataset.desdaReady = '1';

    const $ = (s) => root.querySelector(s);
    const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));
    const now = () => performance.now();
    function hideLoader() { const l = root.querySelector('#loading'); if (l) l.classList.add('--hidden'); }
    function showError(message) { hideLoader(); const st = root.querySelector('#stage'); if (st) st.innerHTML = '<div class="desda-empty">' + message + '</div>'; }

    const dataEl = $('[data-desda-config]');
    let data;
    try { data = JSON.parse(dataEl ? dataEl.textContent : '{}'); } catch (e) { data = {}; }
    if (!data.view || !data.view.length) {
      showError('Bitte im Theme Editor Seitenbilder hinzufügen.');
      return;
    }
    if (!window.St || !window.St.PageFlip) {
      showError('page-flip.browser.js wurde nicht geladen. Bitte die Datei in Assets hochladen.');
      return;
    }

    const stage = $('#stage'), bookEl = $('#book'), bookWrap = $('#bookWrap'), gestures = $('#gestures'), loading = $('#loading');
    const zoomHint = $('#zoomHint'), pageInfo = $('#pageInfo');
    const firstBtn = $('#first'), prevBtn = $('#prev'), nextBtn = $('#next'), lastBtn = $('#last');
    const zoomInBtn = $('#zoomIn'), zoomOutBtn = $('#zoomOut'), fullBtn = $('#full');
    const zoomResetBtn = $('#zoomReset'), zoomPct = $('#zoomPct');
    const gotoInput = $('#gotoInput'), gotoGo = $('#gotoGo'), onboardHint = $('#onboardHint');
    const barToggle = $('#barToggle');

    function setAppHeight() {
      root.style.setProperty('--appH', root.clientHeight + 'px');
      root.style.setProperty('--desda-current-height', root.clientHeight + 'px');
    }
    setAppHeight();

    let manifest = data, pf = null, pageImgs = [];
    const EAGER = 4;
    const MAX_ZOOM = Number(data.maxZoom || 3);
    const reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    let zScale = 1, zTx = 0, zTy = 0, zC = null, natW = 0, natH = 0;
    let hintShown = false, zooming = false;

    try {
      init(manifest);
    } catch (err) {
      console.error('[Desda Pageflip]', err);
      showError('Der Katalog konnte nicht gestartet werden: ' + ((err && err.message) ? err.message : 'Unbekannter Fehler') + '. Bitte prüfe, ob page-flip.browser.js, desda-pageflip.js und mindestens ein Seitenbild vorhanden sind.');
    }

    function init(data) {
      const frag = document.createDocumentFragment();
      data.view.forEach((src, i) => {
        const page = document.createElement('div');
        page.className = 'page';
        if (data.hardCovers && (i === 0 || i === data.view.length - 1)) {
          page.classList.add('--hard');
          page.setAttribute('data-density', 'hard');
        }
        const img = document.createElement('img');
        img.className = 'page-img';
        img.src = src;
        img.alt = (data.alt && data.alt[i]) || ('Seite ' + (i + 1));
        img.decoding = 'async';
        img.loading = i < EAGER ? 'eager' : 'lazy';
        if (i < 2) img.fetchPriority = 'high';
        img.dataset.i = i;
        page.appendChild(img);
        frag.appendChild(page);
      });
      bookEl.appendChild(frag);

      const om = orientationSettings();
      pf = new St.PageFlip(bookEl, {
        width: data.pageWidth || 1408,
        height: data.pageHeight || 1984,
        size: 'stretch',
        minWidth: om.minWidth,
        maxWidth: data.pageWidth || 1408,
        minHeight: om.minHeight,
        maxHeight: data.pageHeight || 1984,
        drawShadow: true,
        flippingTime: reduceMotion ? 1 : 480,
        usePortrait: om.usePortrait,
        autoSize: true,
        maxShadowOpacity: 0.5,
        showCover: !!data.showCover,
        useMouseEvents: false,
        mobileScrollSupport: false
      });
      pf.loadFromHTML(root.querySelectorAll('#book .page'));
      clearEngineMinWidth();
      pageImgs = data.view.map((_, i) => bookEl.querySelector('img[data-i="' + i + '"]'));

      root.DesdaKatalog = { pageFlip: pf, next: navNext, prev: navPrev, first: goFirst, last: goLast, zoomIn: btnZoomIn, zoomOut: btnZoomOut, resetZoom, goTo: gotoPage };

      pf.on('flip', onPageChange);
      pf.on('changeOrientation', onPageChange);
      pf.on('init', updateInfo);

      restoreStartPage();
      updateInfo();
      prefetchNeighbors();
      maybeShowOnboarding();

      const hide = () => loading && loading.classList.add('--hidden');
      const firstImgs = pageImgs.slice(0, Math.min(EAGER, pageImgs.length));
      Promise.all(firstImgs.map((img) => img && img.decode ? img.decode().catch(() => {}) : Promise.resolve())).then(hide);
      setTimeout(hide, 3000);
    }

    function visibleLeaves() {
      if (!pf) return [0];
      const idx = pf.getCurrentPageIndex();
      const n = pf.getPageCount();
      if (pf.getOrientation() === 'portrait') return [idx];
      if (idx <= 0) return [0];
      const left = idx % 2 === 1 ? idx : idx - 1;
      const right = left + 1;
      return right < n ? [left, right] : [left];
    }
    function updateInfo() {
      if (!pf) return;
      const n = pf.getPageCount();
      const v = visibleLeaves();
      pageInfo.textContent = (v.length > 1 ? (v[0] + 1) + '–' + (v[1] + 1) : String(v[0] + 1)) + ' / ' + n;
      const atStart = v[0] <= 0, atEnd = v[v.length - 1] >= n - 1;
      prevBtn.disabled = firstBtn.disabled = atStart;
      nextBtn.disabled = lastBtn.disabled = atEnd;
      updateZoomButtons();
    }
    function onPageChange() { updateInfo(); persistPosition(); prefetchNeighbors(); if (zScale > 1.15) applyHires(); }
    function orientationSettings() {
      return (window.innerWidth > window.innerHeight) ? { usePortrait: false, minWidth: 140, minHeight: 140 } : { usePortrait: true, minWidth: 700, minHeight: 300 };
    }
    function clearEngineMinWidth() { if (bookEl) bookEl.style.minWidth = '0px'; }
    function applyOrientationMode() {
      if (!pf) return;
      const om = orientationSettings();
      const s = pf.getSettings();
      if (s.usePortrait !== om.usePortrait || s.minWidth !== om.minWidth || s.minHeight !== om.minHeight) {
        s.usePortrait = om.usePortrait; s.minWidth = om.minWidth; s.minHeight = om.minHeight;
        try { pf.update(); } catch (_) {}
        clearEngineMinWidth(); updateInfo();
      }
    }
    function navNext() { if (!pf) return; if (zScale > 1) resetZoom(); pf.flipNext(); }
    function navPrev() { if (!pf) return; if (zScale > 1) resetZoom(); pf.flipPrev(); }
    function goFirst() { if (!pf) return; if (zScale > 1) resetZoom(); pf.turnToPage(0); updateInfo(); persistPosition(); }
    function goLast() { if (!pf) return; if (zScale > 1) resetZoom(); pf.turnToPage(pf.getPageCount() - 1); updateInfo(); persistPosition(); }

    firstBtn.addEventListener('click', goFirst); prevBtn.addEventListener('click', navPrev); nextBtn.addEventListener('click', navNext); lastBtn.addEventListener('click', goLast);
    document.addEventListener('keydown', (e) => {
      if (!root.contains(document.activeElement) && !root.matches(':hover')) return;
      if (e.target && (e.target.tagName === 'INPUT' || e.target.isContentEditable)) return;
      if (e.key === 'Escape') { if (zScale > 1) resetZoom(); closeGoto(); return; }
      if (e.key === '+' || e.key === '=') { btnZoomIn(); return; }
      if (e.key === '-' || e.key === '_') { btnZoomOut(); return; }
      if (e.key === 'ArrowRight' || e.key === 'PageDown') navNext();
      else if (e.key === 'ArrowLeft' || e.key === 'PageUp') navPrev();
      else if (e.key === 'Home') goFirst();
      else if (e.key === 'End') goLast();
    });

    const fsEnabled = document.fullscreenEnabled || document.webkitFullscreenEnabled;
    if (!fsEnabled) fullBtn.style.display = 'none';
    fullBtn.addEventListener('click', () => {
      const fsEl = document.fullscreenElement || document.webkitFullscreenElement;
      if (!fsEl) (root.requestFullscreen || root.webkitRequestFullscreen).call(root);
      else (document.exitFullscreen || document.webkitExitFullscreen).call(document);
    });

    function setZooming(on) { zooming = on; bookWrap.classList.toggle('--zooming', on); }
    function beginZoom() { if (zScale === 1) { const r = bookWrap.getBoundingClientRect(); zC = { x: r.left + r.width / 2, y: r.top + r.height / 2 }; natW = r.width; natH = r.height; } }
    function applyT() { bookWrap.style.transform = zScale === 1 ? '' : 'translate(' + zTx + 'px,' + zTy + 'px) scale(' + zScale + ')'; }
    function clampPan() {
      const sr = stage.getBoundingClientRect(); const sw = natW * zScale, sh = natH * zScale;
      const minTx = sr.right - zC.x - sw / 2, maxTx = sr.left - zC.x + sw / 2;
      zTx = (minTx <= maxTx) ? clamp(zTx, minTx, maxTx) : ((sr.left + sr.right) / 2 - zC.x);
      const minTy = sr.bottom - zC.y - sh / 2, maxTy = sr.top - zC.y + sh / 2;
      zTy = (minTy <= maxTy) ? clamp(zTy, minTy, maxTy) : ((sr.top + sr.bottom) / 2 - zC.y);
    }
    function zoomAt(fx, fy, ns) {
      if (!data.enableZoom) return;
      ns = clamp(ns, 1, MAX_ZOOM);
      if (zScale === 1) { if (ns <= 1) return; beginZoom(); }
      if (!zC) beginZoom();
      const ox = (fx - zC.x - zTx) / zScale; const oy = (fy - zC.y - zTy) / zScale;
      zScale = ns; zTx = fx - zC.x - ox * zScale; zTy = fy - zC.y - oy * zScale;
      if (zScale <= 1.001) { resetZoom(); return; }
      clampPan(); applyT(); afterZoomChange();
    }
    function resetZoom() { zScale = 1; zTx = 0; zTy = 0; zC = null; bookWrap.style.transform = ''; setZooming(false); revertHires(); updateZoomButtons(); }
    function settleZoom() { if (zScale > 1 && zScale <= 1.15) resetZoom(); }
    function stageCenter() { const r = stage.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2 }; }
    function afterZoomChange() {
      if (zScale > 1.15 && !zooming) applyHires();
      if (zScale > 1 && !hintShown && zoomHint) { hintShown = true; zoomHint.classList.remove('--hidden'); clearTimeout(afterZoomChange._t); afterZoomChange._t = setTimeout(() => zoomHint.classList.add('--hidden'), 2800); }
      updateZoomButtons();
    }
    function updateZoomButtons() {
      zoomOutBtn.disabled = zScale <= 1.001 || !data.enableZoom;
      zoomInBtn.disabled = zScale >= MAX_ZOOM - 0.001 || !data.enableZoom;
      root.classList.toggle('--zoomed', zScale > 1.001);
      if (zoomPct) zoomPct.textContent = Math.round(zScale * 100) + '%';
    }
    function applyHires() {
      if (!manifest || !manifest.hires) return;
      visibleLeaves().forEach((i) => {
        const img = pageImgs[i]; const hi = manifest.hires[i] || manifest.view[i];
        if (img && img.getAttribute('data-res') !== 'hi' && hi) {
          const pre = new Image();
          const set = () => { if (zScale > 1.15 && visibleLeaves().indexOf(i) !== -1) { img.src = hi; img.setAttribute('data-res', 'hi'); } };
          pre.src = hi; if (pre.decode) pre.decode().then(set, set); else pre.onload = () => { pre.onload = null; set(); };
        }
      });
    }
    function revertHires() { pageImgs.forEach((img, i) => { if (img && img.getAttribute('data-res') === 'hi') { img.src = manifest.view[i]; img.removeAttribute('data-res'); } }); }
    function btnZoomIn() { const c = stageCenter(); zoomAt(c.x, c.y, zScale < 1.05 ? 1.9 : Math.min(MAX_ZOOM, zScale * 1.6)); }
    function btnZoomOut() { const t = zScale / 1.6; if (t <= 1.05) resetZoom(); else { const c = stageCenter(); zoomAt(c.x, c.y, t); } }
    zoomInBtn.addEventListener('click', btnZoomIn); zoomOutBtn.addEventListener('click', btnZoomOut); zoomResetBtn.addEventListener('click', resetZoom);

    const pts = new Map(); let single = null, pinch = null, lastTapT = 0, lastTapXY = null;
    const dist2 = () => { const a = [...pts.values()]; return Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y); };
    const mid2 = () => { const a = [...pts.values()]; return { x: (a[0].x + a[1].x) / 2, y: (a[0].y + a[1].y) / 2 }; };
    gestures.addEventListener('pointerdown', (e) => { closeGoto(); try { gestures.setPointerCapture(e.pointerId); } catch (_) {} pts.set(e.pointerId, { x: e.clientX, y: e.clientY }); if (pts.size === 1) { single = { x0: e.clientX, y0: e.clientY, t0: now(), x: e.clientX, y: e.clientY }; pinch = null; gestures.classList.add('--grabbing'); if (zScale > 1) setZooming(true); } else if (pts.size === 2) { single = null; pinch = { dist: dist2(), scale0: zScale }; setZooming(true); } });
    gestures.addEventListener('pointermove', (e) => { if (!pts.has(e.pointerId)) return; pts.set(e.pointerId, { x: e.clientX, y: e.clientY }); if (pts.size >= 2 && pinch) { const m = mid2(); zoomAt(m.x, m.y, pinch.scale0 * (dist2() / pinch.dist)); } else if (pts.size === 1 && single) { const dx = e.clientX - single.x, dy = e.clientY - single.y; single.x = e.clientX; single.y = e.clientY; if (zScale > 1) { zTx += dx; zTy += dy; clampPan(); applyT(); } } });
    function endPointer(e, allow) {
      pts.delete(e.pointerId); try { gestures.releasePointerCapture(e.pointerId); } catch (_) {}
      if (pts.size >= 2) return;
      if (pts.size === 1) { pinch = null; const p = [...pts.values()][0]; single = { x0: p.x, y0: p.y, t0: now(), x: p.x, y: p.y }; return; }
      gestures.classList.remove('--grabbing');
      if (pinch) { pinch = null; settleZoom(); }
      else if (single) {
        const dx = e.clientX - single.x0, dy = e.clientY - single.y0, dt = now() - single.t0;
        const moved = Math.hypot(dx, dy); const isTap = moved < 10 && dt < 300;
        if (!allow) settleZoom();
        else if (zScale > 1) { if (isTap && isDoubleTap(e.clientX, e.clientY)) resetZoom(); else settleZoom(); }
        else { const horizontal = Math.abs(dx) > Math.abs(dy) * 0.7; if (horizontal && (Math.abs(dx) > 35 || (dt < 260 && Math.abs(dx) > 16))) { if (dx > 0) navPrev(); else navNext(); } else if (isTap && isDoubleTap(e.clientX, e.clientY)) { zoomAt(e.clientX, e.clientY, 2.6); } }
      }
      single = null; setZooming(false); if (zScale > 1.15) applyHires();
    }
    gestures.addEventListener('pointerup', (e) => endPointer(e, true)); gestures.addEventListener('pointercancel', (e) => endPointer(e, false));
    function isDoubleTap(x, y) { const t = now(); if (t - lastTapT < 320 && lastTapXY && Math.hypot(x - lastTapXY.x, y - lastTapXY.y) < 40) { lastTapT = 0; lastTapXY = null; return true; } lastTapT = t; lastTapXY = { x, y }; return false; }
    gestures.addEventListener('wheel', (e) => { if (e.ctrlKey || e.metaKey) { e.preventDefault(); zoomAt(e.clientX, e.clientY, zScale * Math.exp(-e.deltaY * 0.0015)); } }, { passive: false });

    barToggle.addEventListener('click', () => root.classList.toggle('--controls-open'));
    if (data.showToolbar && !(window.matchMedia && window.matchMedia('(pointer: coarse)').matches)) root.classList.add('--controls-open');
    if (!data.showToolbar) { barToggle.style.display = 'none'; $('#toolbar').style.display = 'none'; }

    function currentLeaf() { return visibleLeaves()[0] || 0; }
    function storageKey() { return 'desda-katalog-page-' + (root.id || 'default'); }
    function persistPosition() { const n = currentLeaf() + 1; try { history.replaceState(null, '', '#page=' + n); } catch (_) {} try { localStorage.setItem(storageKey(), String(n)); } catch (_) {} }
    function restoreStartPage() {
      if (!pf) return; let target = NaN; const m = (location.hash || '').match(/page=(\d+)/);
      if (m) target = parseInt(m[1], 10) - 1; else if (data.startPage && data.startPage > 1) target = Number(data.startPage) - 1; else { try { target = parseInt(localStorage.getItem(storageKey()), 10) - 1; } catch (_) {} }
      const n = pf.getPageCount(); if (Number.isFinite(target) && target > 0 && target < n) { try { pf.turnToPage(target); } catch (_) {} }
    }
    function prefetchNeighbors() { if (!manifest) return; const want = new Set(); visibleLeaves().forEach((i) => { want.add(i - 1); want.add(i + 1); want.add(i + 2); }); want.forEach((i) => { const img = pageImgs[i]; if (i >= 0 && i < pageImgs.length && img && !img.dataset.prefetched && img.getAttribute('data-res') !== 'hi') { img.dataset.prefetched = '1'; new Image().src = manifest.view[i]; } }); }
    function gotoPage(n1) { if (!pf) return; const n = clamp((n1 | 0) - 1, 0, pf.getPageCount() - 1); if (zScale > 1) resetZoom(); pf.turnToPage(n); updateInfo(); persistPosition(); prefetchNeighbors(); closeGoto(); }
    function openGoto() { if (!pf) return; gotoInput.max = String(pf.getPageCount()); gotoInput.value = String(currentLeaf() + 1); root.classList.add('--goto-open'); gotoInput.focus(); gotoInput.select(); }
    function closeGoto() { root.classList.remove('--goto-open'); }
    function toggleGoto() { root.classList.contains('--goto-open') ? closeGoto() : openGoto(); }
    pageInfo.addEventListener('click', toggleGoto); pageInfo.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleGoto(); } });
    gotoGo.addEventListener('click', () => gotoPage(parseInt(gotoInput.value, 10))); gotoInput.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); gotoPage(parseInt(gotoInput.value, 10)); } else if (e.key === 'Escape') { e.preventDefault(); closeGoto(); } });
    function maybeShowOnboarding() { if (!data.showOnboarding || !onboardHint) return; let seen = false; try { seen = localStorage.getItem('desda-katalog-onboarded') === '1'; } catch (_) {} if (seen) return; try { localStorage.setItem('desda-katalog-onboarded', '1'); } catch (_) {} setTimeout(() => { onboardHint.classList.remove('--hidden'); setTimeout(() => onboardHint.classList.add('--hidden'), 4200); }, 900); }
    function refreshLayout() {
      setAppHeight();

      // Wichtig: Nach Fullscreen/Resize/Maximieren alte Zoom- und Pan-Werte entfernen.
      // Sonst kann der transformierte Wrapper nach rechts/oben verspringen.
      resetZoom();

      const update = () => {
        setAppHeight();
        applyOrientationMode();

        if (pf) {
          try { pf.update(); } catch (_) {}
          clearEngineMinWidth();
          updateInfo();
          prefetchNeighbors();
        }

        // Sicherheit: Der Wrapper muss nach dem Reflow wieder exakt mittig ohne Transform starten.
        bookWrap.style.transform = '';
      };

      requestAnimationFrame(update);
      setTimeout(update, 120);
      setTimeout(update, 360);
    }

    function onResize() { refreshLayout(); }

    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', () => setTimeout(refreshLayout, 250));
    document.addEventListener('fullscreenchange', () => setTimeout(refreshLayout, 80));
    document.addEventListener('webkitfullscreenchange', () => setTimeout(refreshLayout, 80));
  }

  function boot() { document.querySelectorAll('[data-desda-pageflip]').forEach(initDesdaPageflip); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { if (e.target) e.target.querySelectorAll('[data-desda-pageflip]').forEach(initDesdaPageflip); });
})();
